import { Box, Stack, SxProps, Theme, Typography } from "@mui/material"
import React from "react"
import { Time } from "../../Helper/Time"
import TimeInput from "./TimeInput"

export interface TimeRangeInputProps {
    title?: string
    onChange?: (start: Time | null, end: Time | null) => void
    startTime: Time | null
    endTime: Time | null
    from: Time
    to: Time
    unit?: number
    sx?: SxProps<Theme>
    disabled?: boolean
	disableClear?: boolean
}

const TimeRangeInput: React.FC<TimeRangeInputProps> = ({
    title,
    onChange,
    startTime,
    endTime,
    from,
    to,
    unit,
    sx,
    disabled,
    disableClear,
}) => {
    return (
        <Box sx={sx}>
            {title &&
                <Typography>{title}</Typography>
            }
            <Box>
                <Stack
                    direction={"row"}
                    alignItems="center"
                    spacing={1}
                >
                    <TimeInput
                        value={startTime}
                        onChange={value => {
                            console.log(value)
                            if( value && onChange ) {
                                onChange(value, endTime)
                            }
                        }}
                        min={from}
                        max={to}
                        unit={unit}
                        disableClear={disableClear}
                    />
                    <Typography>～</Typography>
                    <TimeInput
                        value={endTime}
                        onChange={value => {
                            console.log(value)
                            if( value && onChange ) {
                                onChange(startTime, value)
                            }
                        }}
                        min={startTime ?? from}
                        max={to}
                        unit={unit}
                        disableClear={disableClear}
                    />
                </Stack>
            </Box>
        </Box>
    )
}

export default TimeRangeInput